import axiosInstance from "@/lib/axios";
import { verifyUserPath } from "@/config/endpoints";
import { store } from "@/stores/store";
import { setCurrentUser } from "@/stores/slices/authSlice";
import { invalidateAllActiveQueries } from "@/lib/queryClient";

/**
 * POST `/auth/verify` and dispatch `setCurrentUser` so `access_config` + RBAC slice match the server.
 * Use when role/permissions change (socket `user:access_refresh` or manual “refresh all”).
 */
export async function refreshSessionUser(): Promise<void> {
  const res = await axiosInstance.post(verifyUserPath);
  const user = res.data?.user;
  if (user) {
    store.dispatch(setCurrentUser({ user }));
  }
}

/** Hydrate session from server, then invalidate React Query (dashboard, leads, pipeline, etc.). */
export async function refreshSessionUserAndInvalidateQueries(): Promise<void> {
  try {
    await refreshSessionUser();
  } catch {
    /* token invalid — queries may 401; leave to axios interceptors */
  }
  // A permission / branch / CF change shifts data scope everywhere, so we
  // still invalidate every query — but only refetch the ones on screen now
  // (default "active"). The old `invalidateAllQueries` forced `refetchType:
  // "all"`, refetching every background query at once — a request herd when
  // the `user:access_refresh` socket fans out to many users.
  await invalidateAllActiveQueries();
}
